(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MembershipFeeDialogController', MembershipFeeDialogController);

    MembershipFeeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'MembershipFee', 'Profile', 'Dept'];

    function MembershipFeeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, MembershipFee, Profile, Dept) {
        var vm = this;

        vm.membershipFee = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.profiles = Profile.query();
        vm.depts = Dept.query({filter: 'membershipfee-is-null'});
        $q.all([vm.membershipFee.$promise, vm.depts.$promise]).then(function() {
            if (!vm.membershipFee.dept || !vm.membershipFee.dept.id) {
                return $q.reject();
            }
            return Dept.get({id : vm.membershipFee.dept.id}).$promise;
        }).then(function(dept) {
            vm.depts.push(dept);
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.membershipFee.id !== null) {
                MembershipFee.update(vm.membershipFee, onSaveSuccess, onSaveError);
            } else {
                MembershipFee.save(vm.membershipFee, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:membershipFeeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.year = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
